import * as actionTypes from "../actions";

import { addItemInListOfItems, deleteItemByIdInListOfItems, updateItemInListOfItems } from "../../helpers";


const initialState = {
    defaultShiftModalVisible: false,
    customShiftModalVisible: false,
    closedDaysModalVisible: false,

    shifts: [],
    getShiftsLoading: false,
    getShiftsError: null,
    addShiftLoading: false,
    addShiftError: null,
    updateShiftLoading: false,
    updateShiftError: null,
    deleteShiftLoading: false,
    deleteShiftError: null,

    closedDays: [],
    getClosedDaysLoading: false,
    getClosedDaysError: null,
    addClosedDayLoading: false,
    addClosedDayError: null,
    updateClosedDayLoading: false,
    updateClosedDayError: null,
    deleteClosedDayLoading: false,
    deleteClosedDayError: null,
};

const shiftsReducer = (state = initialState, action) => {
    switch (action.type) {
        // TOGGLE DEFAULT SHIFT MODAL
        case actionTypes.TOGGLE_DEFAULT_SHIFT_MODAL:
            return {
                ...state,
                defaultShiftModalVisible: !state.defaultShiftModalVisible
            };

        // TOGGLE CUSTOM SHIFT MODAL
        case actionTypes.TOGGLE_CUSTOM_SHIFT_MODAL:
            return {
                ...state,
                customShiftModalVisible: !state.customShiftModalVisible
            };

        // TOGGLE CLOSED DAY MODAL
        case actionTypes.TOGGLE_CLOSED_DAY_MODAL:
            return {
                ...state,
                closedDayModalVisible: !state.closedDayModalVisible
            };

        // GET SHIFTS
        case actionTypes.GET_SHIFTS_REQUEST:
            return {
                ...state,
                getShiftsLoading: action.loading
            };
        case actionTypes.GET_SHIFTS_SUCCESS:
            return {
                ...state,
                getShiftsLoading: action.loading,
                getShiftsError: action.error,
                shifts: action.shifts
            };
        case actionTypes.GET_SHIFTS_ERROR:
            return {
                ...state,
                getShiftsLoading: action.loading,
                getShiftsError: action.error
            };

        // ADD SHIFT
        case actionTypes.ADD_SHIFT_REQUEST:
            return {
                ...state,
                addShiftLoading: action.loading
            };
        case actionTypes.ADD_SHIFT_SUCCESS:
            return {
                ...state,
                addShiftLoading: action.loading,
                addShiftError: action.error,
                shifts: addItemInListOfItems(
                    state.shifts.filter(shift => !action.deletedShiftIds.includes(shift.id)),
                    action.shift
                )
            };
        case actionTypes.ADD_SHIFT_ERROR:
            return {
                ...state,
                addShiftLoading: action.loading,
                addShiftError: action.error
            };

        // UPDATE SHIFT
        case actionTypes.UPDATE_SHIFT_REQUEST:
            return {
                ...state,
                updateShiftLoading: action.loading
            };
        case actionTypes.UPDATE_SHIFT_SUCCESS:
            return {
                ...state,
                updateShiftLoading: action.loading,
                updateShiftError: action.error,
                shifts: updateItemInListOfItems(
                    state.shifts.filter(shift => !action.deletedShiftIds.includes(shift.id)),
                    action.shift
                )
            };
        case actionTypes.UPDATE_SHIFT_ERROR:
            return {
                ...state,
                updateShiftLoading: action.loading,
                updateShiftError: action.error
            };

        // DELETE SHIFT
        case actionTypes.DELETE_SHIFT_REQUEST:
            return {
                ...state,
                deleteShiftLoading: action.loading
            };
        case actionTypes.DELETE_SHIFT_SUCCESS:
            return {
                ...state,
                deleteShiftLoading: action.loading,
                deleteShiftError: action.error,
                shifts: deleteItemByIdInListOfItems(state.shifts, action.shiftId)
            };
        case actionTypes.DELETE_SHIFT_ERROR:
            return {
                ...state,
                deleteShiftLoading: action.loading,
                deleteShiftError: action.error
            };

        // GET CLOSED_DAYS
        case actionTypes.GET_CLOSED_DAYS_REQUEST:
            return {
                ...state,
                getClosedDaysLoading: action.loading
            };
        case actionTypes.GET_CLOSED_DAYS_SUCCESS:
            return {
                ...state,
                getClosedDaysLoading: action.loading,
                getClosedDaysError: action.error,
                closedDays: action.closedDays
            };
        case actionTypes.GET_CLOSED_DAYS_ERROR:
            return {
                ...state,
                getClosedDaysLoading: action.loading,
                getClosedDaysError: action.error
            };

        // ADD CLOSED_DAY
        case actionTypes.ADD_CLOSED_DAY_REQUEST:
            return {
                ...state,
                addClosedDayLoading: action.loading
            };
        case actionTypes.ADD_CLOSED_DAY_SUCCESS:
            return {
                ...state,
                addClosedDayLoading: action.loading,
                addClosedDayError: action.error,
                closedDays: addItemInListOfItems(state.closedDays, action.closedDay)
            };
        case actionTypes.ADD_CLOSED_DAY_ERROR:
            return {
                ...state,
                addClosedDayLoading: action.loading,
                addClosedDayError: action.error
            };

        // UPDATE CLOSED_DAY
        case actionTypes.UPDATE_CLOSED_DAY_REQUEST:
            return {
                ...state,
                updateClosedDayLoading: action.loading
            };
        case actionTypes.UPDATE_CLOSED_DAY_SUCCESS:
            return {
                ...state,
                updateClosedDayLoading: action.loading,
                updateClosedDayError: action.error,
                closedDays: updateItemInListOfItems(state.closedDays, action.closedDay)
            };
        case actionTypes.UPDATE_CLOSED_DAY_ERROR:
            return {
                ...state,
                updateClosedDayLoading: action.loading,
                updateClosedDayError: action.error
            };

        // DELETE CLOSED_DAY
        case actionTypes.DELETE_CLOSED_DAY_REQUEST:
            return {
                ...state,
                deleteClosedDayLoading: action.loading
            };
        case actionTypes.DELETE_CLOSED_DAY_SUCCESS:
            return {
                ...state,
                deleteClosedDayLoading: action.loading,
                deleteClosedDayError: action.error,
                closedDays: deleteItemByIdInListOfItems(state.closedDays, action.closedDayId)
            };
        case actionTypes.DELETE_CLOSED_DAY_ERROR:
            return {
                ...state,
                deleteClosedDayLoading: action.loading,
                deleteClosedDayError: action.error
            };
        // ADD SPECIAL OPENING
        case actionTypes.ADD_SPECIAL_OPENING_REQUEST:
            return {
                ...state,
                addShiftLoading: action.loading
            };
        case actionTypes.ADD_SPECIAL_OPENING_SUCCESS:
            return {
                ...state,
                addShiftLoading: action.loading,
                addShiftError: action.error,
                shifts: addItemInListOfItems(state.shifts, action.shift)
            };
        case actionTypes.ADD_SPECIAL_OPENING_ERROR:
            return {
                ...state,
                addShiftLoading: action.loading,
                addShiftError: action.error
            };

        default:
            return state;
    }
};

export default shiftsReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/shifts.js